import React, { useState, useEffect } from "react";
import { LuUpload } from "react-icons/lu";
import Kmlread from "./Kmlread";
import { usePredictedYield } from "../../contexts/usePredictedYield";
import { checkPageStatus } from "../../utilityhook/pagecheck"; // ✅ import status check

const InputModal = ({ mapbound }) => {
  const [openImgSelecter, setOpenImgSelecter] = useState(false);
  const [filename, setFile] = useState(null);
  const [isActive, setIsActive] = useState(true); // ✅ new: track page active status

  const [formData, setFormData] = useState({
    start_month: "",
    end_month: "",
    start_year: "",
    end_year: "",
    district: "",
    coordinates: [],
  });

  const { error, loading, fetchPredictedYield } = usePredictedYield();

useEffect(() => {
  const fetchPageStatus = async () => {
    const active = await checkPageStatus("4-yield"); // ✅ wait for backend or localStorage
    setIsActive(active);
  };
  fetchPageStatus();
}, []);


  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const handleCoordinates = (coords) => {
    mapbound(coords);
    setFormData((prevData) => ({
      ...prevData,
      coordinates: coords,
    }));
  };

  const handleSubmit = async () => {
    await fetchPredictedYield(formData);
  };

  const getFileName = (file) => {
    setFile(file);
  };

  return (
    <div className="md:mt-3 bg-base-100 h-[45vh] w-full p-4 rounded-md border overflow-x-hidden overflow-y-auto">
      <div>
        <h1 className="text-xl bg-[#dbeafe] h-10 rounded-sm pt-1 text-center font-bold">
          Yield Monitoring
        </h1>

        {/* Start and End Month-Year Fields */}
        <div className="mt-4 grid grid-cols-2 gap-4">
          {/* Start and End Month */}
          <div>
            <label htmlFor="start_month" className="block text-sm font-bold">
              Start Month
            </label>
            <input
              id="start_month"
              type="number"
              min="1"
              max="12"
              placeholder="1-12"
              className="mt-1 block w-full p-2 border rounded-md border-black"
              value={formData.start_month}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label htmlFor="end_month" className="block text-sm font-bold">
              End Month
            </label>
            <input
              id="end_month"
              type="number"
              min="1"
              max="12"
              placeholder="1-12"
              className="mt-1 block w-full p-2 border rounded-md border-black"
              value={formData.end_month}
              onChange={handleInputChange}
            />
          </div>

          {/* Start and End Year */}
          <div>
            <label htmlFor="start_year" className="block text-sm font-bold">
              Start Year
            </label>
            <input
              id="start_year"
              type="number"
              min="1900"
              max="2100"
              placeholder="e.g., 2023"
              className="mt-1 block w-full p-2 border rounded-md border-black"
              value={formData.start_year}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label htmlFor="end_year" className="block text-sm font-bold">
              End Year
            </label>
            <input
              id="end_year"
              type="number"
              min="1900"
              max="2100"
              placeholder="e.g., 2023"
              className="mt-1 block w-full p-2 border rounded-md border-black"
              value={formData.end_year}
              onChange={handleInputChange}
            />
          </div>
        </div>

        {/* ✅ Conditional Upload Section */}
        {isActive ? (
          // 🌿 Active mode: green upload button
          <div className="flex justify-between items-center mt-4 border p-2 rounded-md border-black">
            <p>{filename || "Upload your KML file"}</p>
            <div
              className="btn flex items-center btn-circle group"
              onClick={() => setOpenImgSelecter(true)}
            >
              <LuUpload size={20} className="mt-3" />
              <span className="relative right-[3vw] top-1/2 transform -translate-y-1/2 bg-black text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {filename || "Upload KML file"}
              </span>
            </div>
          </div>
        ) : (
          // 🔒 Maintenance mode: locked gray upload
          <div className="flex justify-between items-center mt-4 border p-2 rounded-md border-gray-400 bg-gray-200 opacity-70 cursor-not-allowed relative">
            <p className="text-gray-600 flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                className="w-5 h-5 text-gray-500"
              >
                <path
                  fillRule="evenodd"
                  d="M12 1a5 5 0 00-5 5v3H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2v-9a2 2 0 00-2-2h-1V6a5 5 0 00-5-5zm-3 8V6a3 3 0 016 0v3H9z"
                  clipRule="evenodd"
                />
              </svg>
              {filename || "Upload your KML file (Locked)"}
            </p>
            <div className="flex items-center justify-center w-10 h-10 bg-gray-400 rounded-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                className="w-5 h-5 text-white"
              >
                <path
                  fillRule="evenodd"
                  d="M12 1a5 5 0 00-5 5v3H6a2 2 0 00-2 2v9a2 2 0 002 2h12a2 2 0 002-2v-9a2 2 0 00-2-2h-1V6a5 5 0 00-5-5zm-3 8V6a3 3 0 016 0v3H9z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          </div>
        )}

        {/* Area & Crop Selection */}
        <div>
          <label htmlFor="district" className="block mt-1 text-sm font-bold">
            Select your Area
          </label>
          <select
            id="district"
            className="mt-1 block w-full p-2 border rounded-md border-black"
            value={formData.district}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="Naushahro Feroze, Sindh">Naushahro Feroze</option>
            <option value="Punjab">Rahimyarkhan</option>
          </select>
        </div>

        <div>
          <label htmlFor="crop" className="block mt-1 text-sm font-bold">
            Select your Crop
          </label>
          <select
            id="crop"
            className="mt-3 block w-full p-2 border rounded-md border-black"
            onChange={handleInputChange}
          >
            <option value="">Select Your Crop</option>
            <option value="Wheat">Wheat</option>
            <option value="Cotton">Cotton</option>
            <option value="Rice">Rice</option>
          </select>
        </div>

        <button
          className="min-w-fit mt-10 w-full bg-green-500 text-white font-medium py-2 px-2 rounded-md cursor-pointer hover:bg-green-600 duration-300"
          onClick={handleSubmit}
          disabled={loading || !isActive} // 🔒 disable if inactive
        >
          {loading ? "Loading..." : "Predict Yield"}
        </button>

        {error && <p className="text-red-500">Error: {error}</p>}
      </div>

      {openImgSelecter && (
        <Kmlread
          getFileName={getFileName}
          setOpenImgSelecter={setOpenImgSelecter}
          handleCoordinates={handleCoordinates}
        />
      )}
    </div>
  );
};

export default InputModal;
